import { Formattable } from "./Formattable";
import promptConstants from "./constants/prompt.constants.json";
import {
  IMultiCustId,
  IPromptCommonData,
  IPromptUserDetails,
  IRelationshipDetails,
  ITarsierCommon,
  IUserDetails,
} from "./types/common.types";

export class TarsierCommon implements ITarsierCommon {
  constructor(private commonData: IPromptCommonData) {}

  private _dotNotationToObject<T>(obj: object, dotNotation: string): T | null {
    const keys = dotNotation.split(".") as Array<keyof unknown>;

    return keys.reduce((acc, key) => {
      if (acc && typeof acc === "object" && key in acc) {
        return acc[key as keyof unknown];
      }
      return undefined;
    }, obj as unknown) as T;
  }

  private _guardClause(): boolean {
    return !!this.commonData;
  }

  userDetails(): Formattable<IUserDetails> {
    if (!this._guardClause()) return new Formattable("");
    const customDemogDetails = this._dotNotationToObject<IPromptUserDetails[]>(
      this.commonData,
      promptConstants.userDetails.custDemogDetails
    );
    if (!customDemogDetails) return new Formattable("");
    const [_custDemogDetails, ..._remCustDemogDetails] = customDemogDetails;
    const _multiCustIds = _remCustDemogDetails.map(
      (custDetails) =>
        ({
          ...custDetails,
          city: custDetails.cityName,
          custId: custDetails.id,
        }) as unknown as IMultiCustId
    );
    _multiCustIds.unshift({
      ..._custDemogDetails,
      city: _custDemogDetails?.cityName,
      custId: _custDemogDetails?.id,
    } as unknown as IMultiCustId);
    return new Formattable({
      ..._custDemogDetails,
      custType: this._dotNotationToObject<string>(
        this.commonData,
        promptConstants.userDetails.custType
      ),
      city: _custDemogDetails?.cityName,
      custId: _custDemogDetails?.id,
      reKycFlag: _custDemogDetails?.rekycFlag,
      kycRenewalDate: _custDemogDetails?.kycrenewaldate,
      multipleCustIds: _multiCustIds,
      firstName: _custDemogDetails?.firstName ?? "",
      lastName: _custDemogDetails?.lastName ?? "",
      fullName: _custDemogDetails?.fullName ?? "",
    });
  }

  relationshipDetails(): Formattable<IRelationshipDetails> {
    if (!this._guardClause()) return new Formattable("");
    const relationshipDetails = this._dotNotationToObject(
      this.commonData,
      promptConstants.relationshipDetails
    );
    if (!relationshipDetails) return new Formattable("");
    return new Formattable(relationshipDetails);
  }
}
